import toast from "../components/toast";
//加载appapi方法
export const waitPlusReady = (readyCB) => {
  return new Promise((resolve) => {
    if ("plus" in window && !window.plus.isReady) {
      document.addEventListener("plusready", () => {
        readyCB?.();
        resolve();
      });
    } else {
      readyCB?.();
      resolve();
    }
  });
};

//退出饮用
export const confirmToQuit = () => {
  const plus = window?.plus;
  let first = null;
  //定义不能左滑的页面路由(一级)
  const pathArr = [
    "#/member",
    "#/",
    "#/sale",
    "#/order",
    "#/bet-order",
    "#/mine",
    "#/score",
  ];
  const onPressBack = function () {
    const webview = plus.webview.currentWebview();
    webview.canBack(function (e) {
      if (e.canBack && !pathArr.includes(window.location.hash)) {
        window.history.back(); //这里不建议修改自己跳转的路径
      } else {
        //首次按键，提示‘再按一次退出应用’
        if (!first) {
          //pay
          if (
            plus.webview.getDisplayWebview()?.length == 2 &&
            plus.webview.getDisplayWebview()[1].id == "embed"
          ) {
            plus.webview.close("embed", "slide-out-left", 500);
          } else {
            // TopToast.info('再按一次退出应用')
          }

          first = Date.now(); //获取第一次点击的时间戳
          // console.log('再按一次退出应用');//用自定义toast提示最好
          toast('双击返回键退出应用'); //调用自己写的吐丝提示 函数

          // plus.nativeUI.toast('再按一次退出应用', {
          //   duration: 'short',
          // }) //通过H5+ API 调用Android 上的toast 提示框
          setTimeout(() => (first = null), 1000);
        } else {
          if (Date.now() - first < 1000) {
            //获取第二次点击的时间戳, 两次之差 小于 1000ms 说明1s点击了两次,
            plus.runtime.quit(); //退出应用
          }
        }
      }
    });
  };

  plus?.key.addEventListener("backbutton", onPressBack);
  return () => plus?.key.removeEventListener("backbutton", onPressBack);
};
